import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa' 
import {Fa500Px} from 'react-icons/fa'
import {SiMedium} from 'react-icons/si'

const HeaderSocials = () => {
  return (
    <div className="header__socials">
        <a href="https://linkedin.com/in/anuradha-basnayake" target='_blank'><BsLinkedin /></a>
        <a href="https://github.com/cloby99" target='_blank'><FaGithub /></a>
        <a href="https://500px.com/p/cloby99" target='_blank'><Fa500Px /></a>
        <a href="https://medium.com/@cloby99" target='_blank'><SiMedium /></a>
    </div>
  )
}

export default HeaderSocials